import { Column, Columns } from 'braid-design-system';

import type {
  ClientListingForListingsTab,
  ListingProductForListingsTab,
} from 'src/types/graphql-derived';

import Actions from './components/Actions/Actions';
import Statistics from './components/Statistics/Statistics';

interface DetailsProps {
  listing: ClientListingForListingsTab;
  expireFunction: () => void;
  isProcessing: boolean;
  listingProducts: ListingProductForListingsTab[];
}

const Details = ({
  listing,
  expireFunction,
  isProcessing,
  listingProducts,
}: DetailsProps) => (
  <Column>
    <Columns space="large" collapseBelow="tablet" reverse={true}>
      <Column>
        <Statistics listing={listing} />
      </Column>

      <Column>
        <Actions
          listing={listing}
          expireFunction={expireFunction}
          isProcessing={isProcessing}
          listingProducts={listingProducts}
        />
      </Column>
    </Columns>
  </Column>
);

export default Details;
